import { Stack } from '@material-ui/core';
import { Skeleton } from '@mui/material';
import React from 'react';

import { DocumentsTabStyledContainer } from './StyledComponents';

function DocumentsTabSkeleton() {
  return (
    <DocumentsTabStyledContainer>
      <Stack spacing={"20px"} direction={'column'}>
        <Skeleton variant="rounded" width={'100%'} height={225} />
        <Skeleton variant="rounded" width={'100%'} height={225} />
      </Stack>
    </DocumentsTabStyledContainer>
  );
}

export { DocumentsTabSkeleton };
